import React from 'react';
import { motion } from 'framer-motion';
import { InfiniteLogoScroll } from './InfiniteLogoScroll';
import { AnimatedCounter } from './AnimatedText';
import { FadeUpOnScroll } from './ScrollReveal';

export const TrustStripUltimate = () => {
  // Nur echte, verifizierbare Fakten
  const stats = [
    { value: 100, suffix: '%', label: 'TSE-konform' },
    { value: 99.9, suffix: '%', label: 'Uptime', isDecimal: true },
    { value: 24, suffix: '/7', label: 'Deutscher Support' },
    { value: 0, suffix: '€', label: 'Einrichtungsgebühr' }
  ];

  return (
    <section
      data-testid="trust-strip-section"
      className="relative py-16 md:py-24 overflow-hidden"
      style={{ backgroundColor: '#080d18' }}
    >
      {/* Subtle gradient overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, rgba(11,18,32,0.8) 0%, transparent 50%, rgba(11,18,32,0.8) 100%)'
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <FadeUpOnScroll className="text-center mb-12">
          <p className="text-sm uppercase tracking-wider text-slate-500 mb-2">Made in Germany</p>
          <h3 className="text-2xl font-semibold text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Integriert mit Ihren Lieblings-Plattformen
          </h3>
        </FadeUpOnScroll>

        {/* Infinite Logo Scroll */}
        <InfiniteLogoScroll className="py-8" />

        {/* Stats Grid */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <FadeUpOnScroll key={stat.label} delay={i * 0.1}>
              <div className="text-center">
                <motion.p 
                  className="text-4xl md:text-5xl font-bold text-white"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {stat.isDecimal ? (
                    <span>{stat.value}{stat.suffix}</span>
                  ) : (
                    <AnimatedCounter value={stat.value} suffix={stat.suffix} />
                  )}
                </motion.p>
                <p className="mt-2 text-sm text-slate-400">{stat.label}</p>
              </div>
            </FadeUpOnScroll>
          ))}
        </div>

        {/* Cities */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center mt-12 text-sm text-slate-500"
        >
          Verfügbar in Berlin, München, Hamburg, Köln, Frankfurt, Stuttgart, Düsseldorf und ganz Deutschland.
        </motion.p>
      </div>
    </section>
  );
};

export default TrustStripUltimate;
